export const SEARCH_DELAY = 500;
export const DEFAULT_MAX_ENTRIES: number = 30;

export const statusOptions = [
    { label: 'Neu', value: 'NEW' },
    { label: 'Archiviert', value: 'ARCHIVED' },
];

export const delieveredOptions = [
    { label: 'Geliefert', value: true },
    { label: 'Nicht geliefert', value: false },
];

export const MAX_TRAINING_ANSWERS = 6;
export const MATEN_LOGIN_PREFIX: string = 'log'; // Prefix für Login Tokens
export const MATEN_ACCESS_PREFIX: string = 'acc'; // Prefix für Access Tokens

export const MATEN_WEBSITE: string = 'https://www.maten.ai';
